import { render } from "./askView.vue?vue&type=template&id=71732677"
import script from "./askView.vue?vue&type=script&lang=js"
export * from "./askView.vue?vue&type=script&lang=js"

import "./askView.vue?vue&type=style&index=0&id=71732677&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__